import React, { useState, useRef } from "react";
import "./Transportation_of_building_materials.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Transporting_wood() {
  return (
    <div className="Transportation_of_building_materials-page">

      <div className="Transportation_of_building_materials-hero">
        <div className="Transportation_of_building_materials-overlay">
          <h1>הובלת עצים</h1>
        </div>
      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            הובלת עצים דורשת תכנון נכון, ציוד מתאים וניסיון בעבודה
            עם מטענים ארוכים, כבדים ובעלי מידות שונות. נצר הובלות
            ומנופים מספקת שירותי הובלת עצים לקבלנים, חברות, עסקים,
            מחסני עצים ולקוחות פרטיים, בהתאם לסוג העץ, כמות המטען
            ותנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/31.jpeg"
                alt="הובלת עצים"
              />
            </div>

            <div className="text-box">

              <p>
                הובלת עצים דורשת התאמה בין סוג העץ, אורך וגודל המטען,
                המשקל ותנאי הגישה בנקודת האיסוף והפריקה. לפני ביצוע
                ההובלה חשוב לבחון את סוג המטען, כמות העצים, אופן
                ההעמסה והפריקה והאפשרות להגיע בבטחה לנקודת היעד.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות להובלת עצים מסוגים
                שונים, לרבות קורות עץ, לוחות, עצים לבנייה, עצי גינון,
                גזעי עץ, משטחי עץ ומטעני עץ נוספים, בהתאם לסוג העבודה
                ולתנאים בשטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הובלת עצים – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל הובלת עצים מתחילה בבדיקת פרטי ההובלה. יש להבין מהו
              סוג המטען, מה הכמות, מה המשקל הכולל, מהן מידות העצים
              ומהי נקודת האיסוף והפריקה.
            </p>

            <p>
              בנוסף יש לבחון את תנאי הדרך ואת הגישה לאתר, לרבות רחובות
              צרים, כניסות מורכבות, אתרי בנייה, חצרות ומגבלות אחרות
              שעלולות להשפיע על ביצוע ההובלה.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הובלת עצים באמצעות משאית
            </h2>

            <p>
              משאית מתאימה מאפשרת להעביר עצים ומוצרי עץ ממקום אחד
              לאחר בצורה מסודרת ובטוחה. התאמת המשאית נעשית בהתאם
              לאורך המטען, למשקל, לכמות העצים ולתנאי הגישה.
            </p>

            <p>
              במקרים שבהם יש צורך גם בהעמסה או בפריקה באמצעות מנוף,
              ניתן לשלב שירות הובלה ומנוף בהתאם לדרישות העבודה
              ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הובלת עצים לאתרי בנייה
            </h2>

            <p>
              באתרי בנייה יש לעיתים צורך בהובלה של קורות, לוחות,
              עצים לבנייה וחומרי עץ נוספים. הובלה מסודרת מאפשרת
              להעביר את המטען אל האתר בהתאם לשלבי הפרויקט ולצרכים
              של העבודה.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי הובלת עצים לאתרי בנייה,
              עסקים, מחסנים ונקודות שונות ברחבי הארץ, בהתאם לצורכי
              הלקוח ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הובלת עצים עם מנוף
            </h2>

            <p>
              במקרים שבהם נקודת הפריקה אינה נגישה ישירות למשאית,
              ניתן להשתמש במנוף לצורך הרמת העצים והעברתם אל נקודת
              הפריקה המתאימה, בהתאם לאפשרויות העבודה בשטח.
            </p>

            <p>
              שילוב של הובלה ומנוף יכול לסייע במקרים שבהם נדרשת
              הרמה של קורות, לוחות, גזעים או מטעני עץ אל אזורים
              שבהם אין אפשרות לפריקה רגילה.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              הובלת קורות, לוחות וגזעי עץ
            </h2>

            <p>
              עצים ומוצרי עץ מגיעים במגוון גדלים, אורכים ומשקלים.
              קורות ארוכות, לוחות, גזעים ומשטחי עץ דורשים תכנון
              מתאים של ההובלה ושל אופן ההעמסה והפריקה.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את ההובלה כך שתתאים
              לאורך המטען, לכמות העצים, למשקל ולתנאי הגישה באתר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להובלת עצים?
            </h2>

            <p>
              הובלת עצים דורשת היכרות עם סוגי מטענים שונים, תכנון
              נכון והתאמת אמצעי ההובלה למשימה. בדיקה מוקדמת של
              תנאי השטח יכולה לסייע בתכנון יעיל של ההובלה.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון ההובלה לסוג העץ,
              לאורך המטען, לכמות, למשקל, לתנאי הדרך ולדרישות הפרויקט.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – הובלת עצים בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הובלת עצים,
              קורות, לוחות, גזעים ומוצרי עץ למגוון לקוחות,
              לרבות עסקים, קבלנים, אתרי בנייה ולקוחות פרטיים.
              השירות ניתן בהתאם לסוג המטען ולתנאים הקיימים בשטח.
            </p>

            <p>
              צריכים הובלת עצים? צרו איתנו קשר, ספרו לנו מה אתם
              צריכים להוביל ונבחן עבורכם את פתרון ההובלה המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Transportation_of_building_materials"
              className="link-right"
            >
הובלת חומרי בניין
           </Link>

            <Link
              to="/Transporting_heavy_equipment"
              className="link-left"
            >
              הובלת ציוד כבד
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
